import { useEffect, useState } from "react";

import { Switch } from "@frontend/components/atoms/Switch";

import { type Collection, profilerApi } from "../api";

// Whether the requests of this browser are profiled. In debug every
// request is, and the switch only says so.
export function CollectionSwitch() {
  const [collection, setCollection] = useState<Collection | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    profilerApi
      .fetchCollection({ signal: controller.signal })
      .then(setCollection)
      .catch(() => {
        if (!controller.signal.aborted) {
          setCollection(null);
        }
      });

    return () => controller.abort();
  }, []);

  if (!collection) {
    return null;
  }

  return (
    <Switch
      label={
        collection.always
          ? "Every request is profiled (debug)"
          : "Profile my requests"
      }
      checked={collection.always || collection.enabled}
      disabled={collection.always}
      onCheckedChange={(checked) => {
        void profilerApi
          .updateCollection(checked)
          .then(setCollection)
          .catch(() => undefined);
      }}
    />
  );
}
